<template>
  <div class="countdown" :class="{hidden: !visible}">
    <span class="seconds">{{second}}</span>
  </div>
</template>

<script>
export default {
  props: {
    seconds: {
      type: Number,
      required: true,
    },
    visible: {
      type: Boolean,
      default: true,
    },
    autoPlay: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      timer: null,
      second: this.seconds,
    };
  },
  mounted() {
    if (this.autoPlay) {
      this.start();
    }
  },
  destroy() {
    this.stop();
  },
  methods: {
    start(isReset = true) {
      this.stop();
      if (isReset) {
        this.second = this.seconds;
      }
      this.timer = setInterval(() => {
        if (this.second === 0) {
          this.stop();
          this.$emit('timeout');
        } else {
          this.second -= 1;
        }
      }, 1000);
    },
    stop() {
      clearInterval(this.timer);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';

  .countdown {
    position: relative;
    width: 61px;
    height: 61px;
    text-align: center;
    &.hidden {
      display: none;
    }
    .icon-sun {
      font-size: 55px;
      color: $primary;
    }
    .seconds {
      width: 100%;
      text-align: center;
      line-height: 61px;
      font-size: 30px;
      color: $primary;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
</style>
